<app-adjustment-forms [disableSubmit]="disableSubmit" [info]="info" [success]="success" (adjustmentDetails)="performAdjustment($event)" (changeRows)="changeRows($event)"></app-adjustment-forms>
